
// @ts-nocheck


export const localeCodes =  [
  "en_EN",
  "nl_NL",
  "fr_FR"
]

export const localeLoaders = {
  "en_EN": [],
  "nl_NL": [],
  "fr_FR": []
}

export const vueI18nConfigs = [
  () => import("../locales/i18n.config.ts?hash=91504c8a&config=1" /* webpackChunkName: "locales_i18n_config_ts_91504c8a" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "locales/i18n.config.ts",
  "locales": [
    "en_EN",
    "nl_NL",
    "fr_FR"
  ],
  "defaultLocale": "en_EN",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": true,
    "cookieDomain": null,
    "cookieKey": "i18n",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "iso": "en_EN",
    "code": "en_EN"
  },
  {
    "iso": "nl_NL",
    "code": "nl_NL"
  },
  {
    "iso": "fr_FR",
    "code": "fr_FR"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
